import { combineReducers } from "redux";

import authReducers from "./auth.reducers";
import pageReducers from "./page.reducers";
import notifyReducer from "./notify.reducer";

const reducer = combineReducers({
  auth: authReducers,
  page: pageReducers,
  notify: notifyReducer,
});

export default reducer;
